import { render } from "./Auth2fa.vue?vue&type=template&id=8a176ba0&scoped=true"
import script from "./Auth2fa.vue?vue&type=script&lang=js"
export * from "./Auth2fa.vue?vue&type=script&lang=js"

import "./Auth2fa.vue?vue&type=style&index=0&id=8a176ba0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a176ba0"]])

export default __exports__